$mol_button_major $mol_button_typed
	attr *
		^
		mol_theme \$mol_theme_accent
